module.exports = __webpack_public_path__ + "img/alipay.70c3ee1f.png";